import React from "react";
import { useTheme } from "styled-components";
import VideoPlayerButtonComponent from "../../VideoPlayerButton";

const NextEpisodeButton = ({ nextProgram, translate, skipToNextEpisode, spinnerToggle }) => {
  const theme = useTheme();
  if (!nextProgram) {
    return null;
  }

  return (
    <VideoPlayerButtonComponent
      src={process.env.PUBLIC_URL + "/images/cta-next-ep.svg"}
      alt={translate("next_episode")}
      buttonClassName="playbackButton"
      onClickHandler={skipToNextEpisode}
      disabled={spinnerToggle}
      tooltipDirection="top"
      $hoverBackgroundColor={theme.colours.mineShaftGray}
    />
  );
};

export default NextEpisodeButton;
